import {CommonMessages} from '../common.messages';

export const PanelReportsCampaignsMessages = {
    GetCampaignsFailed: {
        key: 'GetCampaignsFailed',
        message: 'Error while communication with the server. Unable to get the campaign registry.'
    },
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while communication with the server. Unable to get the Campaign Funnel report.'
    },
    GetDetailsFailed: {
        key: 'GetDetailsFailed',
        message: 'Error while communication with the server. Unable to get the campaign drill-down.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    MissingDateRange: {
        key: 'MissingDateRange',
        message: 'Date From and Date To are required.'
    },
    ...CommonMessages
};
